// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge[data-v-6cb3fe23] {\n  position: absolute;\n  right: 0;\n  top: 0;\n  display: inline-block;\n  padding: 0.2em 0.3em;\n  color: #fff;\n  line-height: 1;\n  font-weight: bold;\n  font-size: 0.8em;\n  background: var(--v-info-base);\n  border-radius: 10em;\n  -webkit-transform: translateY(-55%) translateX(45%);\n          transform: translateY(-55%) translateX(45%);\n}", ""]);
// Exports
module.exports = exports;
